import { render } from "./Checkbox.vue?vue&type=template&id=43904934&scoped=true"
const script = {}

import "./Checkbox.vue?vue&type=style&index=0&id=43904934&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-43904934"

export default script